import { isOperatingZone, availableLanguagesByOperatingZone } from '@orus.eu/operating-zone'
import { isLanguage, type Language } from '@orus.eu/translations'

/**
 * The language explicitly requested through the url, which takes precedence over any language we
 * would otherwise infer.
 */
export function getDefaultLanguageFromUrl(): Language | undefined {
  const url = new URL(document.location.href)

  const languageUrlParameter = url.searchParams.get('language')
  if (languageUrlParameter && isLanguage(languageUrlParameter)) {
    return languageUrlParameter
  }

  const operatingZoneUrlParameter = url.searchParams.get('operating_zone') ?? url.searchParams.get('operatingZone')
  if (operatingZoneUrlParameter && isOperatingZone(operatingZoneUrlParameter)) {
    return availableLanguagesByOperatingZone[operatingZoneUrlParameter]?.primaryLanguage
  }

  return undefined
}
